module.exports = __webpack_public_path__ + "img/weixin.8f0e9ba9.svg";